import {SPECIAL_BUILDING_CONFIGS} from "../../configs/tokens";

export const checkIfSpecialBuilding = (buildingId) => {
  return SPECIAL_BUILDING_CONFIGS.some(building => building.id === buildingId)
}